/**
 * @module compoenents/StationInfo
 * @author Charles Blais <charles.blais@canada.ca>
 */
import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import { getStatusIndicator, getStatusColor } from '../../libs/display';
import { useLanguageState } from '../../contexts/LanguageProvider';
import { useAppState } from '../../contexts/AppStateProvider';

import { Station } from '../../libs/networks';


const StationSummaryTable = ({networkCode, station, ...props}) => {
  const [ lang ] = useLanguageState();
  const [ state ] = useAppState();

  const statusIndicator = getStatusIndicator(station);
  let status = ''
  switch(statusIndicator){
    case -1:
      status = lang.close;
      break;
    case 0:
      status = lang.open;
      break;
    case 1:
      status = lang.planned;
      break;
    default:
      status = '';
  }

  return (
    <Table bordered hover {...props}>
      <tbody>
        <tr>
          <th>{lang.network}</th>
          <td>{(networkCode in lang.networkCodes)?lang.networkCodes[networkCode]:networkCode}</td>
        </tr>
        <tr>
          <th>{lang.station}</th>
          <td>{station.code}</td>
        </tr>
        <tr>
          <th>{lang.status}</th>
          <td style={{backgroundColor:getStatusColor(station)}}>{status}</td>
        </tr>
        <tr>
          <th>{lang.name}</th>
          <td>{station.name}</td>
        </tr>
        <tr>
          <th>Latitude (&deg;)</th>
          <td>{station.latitude}</td>
        </tr>
        <tr>
          <th>Longitude (&deg;)</th>
          <td>{station.longitude}</td>
        </tr>
        <tr>
          <th>{lang.elevation} (<abbr title={lang.meters}>m</abbr>)</th>
          <td>{station.elevation}</td>
        </tr>
        { station.starttime && statusIndicator !== 1 && 
          <tr>
            <th>{lang.startDate}</th>
            <td>{station.starttime.format(state.datetimeFormat)}</td>
          </tr>
        }
        { station.endtime && statusIndicator !== 1 &&
          <tr>
            <th>{lang.endDate}</th>
            <td>{station.endtime.format(state.datetimeFormat)}</td>
          </tr>
        }
      </tbody>
    </Table>
  );
}


StationSummaryTable.propTypes = {
  /**
   * Network code of the selected station
   */
  networkCode: PropTypes.string.isRequired,
  /**
   * Station object with required channels information
   */
  station: PropTypes.instanceOf(Station).isRequired,
};


export default StationSummaryTable;